<template>
  <div style="background-color: white; padding: 10px; border-radius: 5px;" v-if="tnc_link && privacy_link">
    <p v-html="text"></p>
  </div>
</template>

<script>
import { http } from 'utils'
export default {
  data () {
    return {
      tnc_link: null,
      privacy_link: null
    }
  },
  mounted () {
    this.getLinks().then(response => {
      this.tnc_link = response.data.tnc_link
      this.privacy_link = response.data.privacy_link
    })
  },
  computed: {
    text () {
      let text = this.$t('privacy_policy')
      text = text.replace('{{ privacy_link }}', this.privacy_link)
      text = text.replace('{{ tnc_link }}', this.tnc_link)
      return text
    }
  },
  methods: {
    getLinks () {
      return http.get('public_settings')
    }
  }
}
</script>
